<template>
  <div>
    <modal
      name="timeconstraint"
      :adaptive="true"
      :scrollable="true"
      @before-open="setConstraint"
      height="auto"
      width="75%"
    >
      <div class="modal-wrapper">
        <div class="modal-header">
          <h2 class="title is-3" v-if="existing">
            {{ $t("edit-time-date-constraints") }}
          </h2>
          <h2 class="title is-3" v-else>{{ $t("add-time-date-constraints") }}</h2>
        </div>
        <div class="modal-content" style="width: 100%">
          <div class="p-grid">
            <div class="p-col-12">
              <div>
                <b-field :label="$t('choose-constraint-style')"></b-field>
                <b-radio v-model="d1" name="Weekly Constrant" native-value="0">{{ $t("weekly-constraint") }}</b-radio>
                <b-radio v-model="d1" name="Specific Date" native-value="1">{{ $t("specific-date") }}</b-radio>
                <b-radio v-model="d1" name="Date Range" native-value="2">{{ $t("date-range") }}</b-radio>
              </div>
              <div class="mt-3">
                <div v-if="isSpecificDate" class="p-text-center">
                  <b-field :label="$t('select-date')"></b-field>
                  <div v-show="showDatepicker" id="datePicker" class="p-text-center"></div>
                  <AirbnbStyleDatepicker
                    v-show="showDatepicker"
                    :monthsToShow="1"
                    triggerElementId="datePicker"
                    @date-one-selected="setStartDate"
                    :mode="'single'"
                    :inline="true"
                    :startOpen="true"
                    style="margin: 0 auto"
                    :close-after-select="true"
                  />
                  <div class="p-my-3 p-text-center" v-if="constraint.start_date">
                    {{ $t("date-selected") }}: {{ constraint.start_date }}
                  </div>
                </div>
                <div v-else-if="isRange">
                  <b-field :label="$t('select-date-range')"></b-field>
                  <div v-show="showDatepicker" id="datePicker" class="p-text-center"></div>
                  <AirbnbStyleDatepicker
                    :monthsToShow="1"
                    triggerElementId="datePicker"
                    @date-one-selected="setStartDate"
                    @date-two-selected="setEndDate"
                    :mode="'range'"
                    :inline="true"
                    :startOpen="true"
                    style="margin: 0 auto"
                  />
                  <div class="p-my-3 p-text-center" v-if="constraint.start_date">
                    {{ $t("range-selected") }}: {{ constraint.start_date }} - {{ constraint.end_date }}
                  </div>
                </div>
                <div v-else-if="isWeekly">
                  <b-field :label="$t('select-day-s-of-week')"></b-field>
                  <b-checkbox
                    v-for="d in days"
                    :key="d.value"
                    v-model="constraint.weekdays"
                    name="Specific Date"
                    :native-value="d.value"
                    >{{ d.name }}</b-checkbox
                  >
                </div>
                <div v-if="step2" class="mt-3">
                  <b-field :label="$t('choose-constraint-type')"></b-field>
                  <b-radio v-model="d2" name="All Day NoPlay" :native-value="0">{{ $t("noplay-all-day") }}</b-radio>
                  <b-radio v-model="d2" name="Time Range NoPlay" :native-value="1">{{
                    $t("noplay-time-range")
                  }}</b-radio>
                  <b-radio v-if="isWeekly" v-model="d2" name="Max Games Limit" :native-value="2">{{
                    $t("max-games-limit")
                  }}</b-radio>
                  <b-radio v-if="isWeekly" v-model="d2" name="Max travel from Home" :native-value="3">{{
                    $t("max-travel-from-home")
                  }}</b-radio>

                  <b-radio v-if="isWeekly" v-model="d2" name="Max travel from Last" :native-value="4">{{
                    $t("max-travel-from-last")
                  }}</b-radio>
                  <b-radio v-if="isWeekly" v-model="d2" name="Must play at home" :native-value="5">{{
                    $t("must-be-at-home")
                  }}</b-radio>
                  <b-radio v-if="isWeekly" v-model="d2" name="Cannot play a team" :native-value="6">{{
                    $t("cannot-play-a-team")
                  }}</b-radio>
                </div>

                <div v-if="step3" class="p-my-5">
                  <div v-if="timerange">
                    <b-field :label="$t('choose-time-range')"></b-field>
                    <div class="columns is-vcentered p-text-center">
                      <div class="column">
                        <p>{{ $t("cannot-play-between") }}</p>
                        <b-timepicker
                          :disabled="!!times.c || !!times.d"
                          inline
                          :default-minutes="0"
                          @input="setBetweenStart"
                          v-model="times.a"
                          :incrementMinutes="15"
                          hour-format="12"
                        ></b-timepicker>
                        <p class="my-1">and</p>
                        <b-timepicker
                          :disabled="!!times.c || !!times.d"
                          v-model="times.b"
                          inline
                          :default-minutes="0"
                          @input="setBetweenEnd"
                          :incrementMinutes="15"
                          hour-format="12"
                        ></b-timepicker>
                        <br />
                        <a @click="clear(1)"> {{ $t("Button.reset") }} </a>
                      </div>
                      <div class="column is-1">or</div>
                      <div class="column">
                        <p>{{ $t("cannot-play-before") }}</p>
                        <b-timepicker
                          :disabled="!!times.a || !!times.b"
                          v-model="times.c"
                          inline
                          :default-minutes="0"
                          @input="setNotBefore"
                          :incrementMinutes="15"
                          hour-format="12"
                        ></b-timepicker>
                        <p class="my-1">{{ $t("or-after") }}</p>
                        <!-- <TimePicker
                          format="hh:mm a"
                          manual-input
                          :minute-interval="15"
                          @change="setNotAfter"
                          close-on-complete
                        ></TimePicker> -->
                        <b-timepicker
                          :disabled="!!times.a || !!times.b"
                          v-model="times.d"
                          inline
                          :default-minutes="0"
                          @input="setNotAfter"
                          :incrementMinutes="15"
                          hour-format="12"
                        ></b-timepicker>
                        <br />
                        <a @click="clear(2)"> {{ $t("Button.reset") }} </a>
                      </div>
                    </div>
                  </div>
                  <div v-else-if="maxgames" class="p-text-center">
                    <InputNumber
                      id="horizontal"
                      v-model="constraint.max_games"
                      showButtons
                      buttonLayout="horizontal"
                      :step="1"
                      :min="0"
                      decrementButtonClass="dsButton"
                      incrementButtonClass="dsButton"
                      incrementButtonIcon="pi pi-plus"
                      decrementButtonIcon="pi pi-minus"
                    />
                  </div>
                  <div v-else-if="maxhome" class="p-text-center">
                    <InputNumber
                      id="horizontal"
                      v-model="constraint.max_travel_home"
                      showButtons
                      buttonLayout="horizontal"
                      :step="1"
                      :min="1"
                      decrementButtonClass="dsButton"
                      incrementButtonClass="dsButton"
                      incrementButtonIcon="pi pi-plus"
                      decrementButtonIcon="pi pi-minus"
                    />
                    <br />
                    {{ $t("miles") }}
                  </div>
                  <div v-else-if="maxlast" class="p-text-center">
                    <InputNumber
                      id="horizontal"
                      v-model="constraint.max_travel_last"
                      showButtons
                      buttonLayout="horizontal"
                      :step="1"
                      :min="1"
                      decrementButtonClass="dsButton"
                      incrementButtonClass="dsButton"
                      incrementButtonIcon="pi pi-plus"
                      decrementButtonIcon="pi pi-minus"
                    />
                    <br />
                    {{ $t("miles") }}
                  </div>
                  <div v-else-if="noteam" class="p-text-center">
                    <span> {{ $t("choose-no-play-team") }} </span>
                    <br /><br />
                    <Dropdown
                      style="width: 200px"
                      class="w100"
                      :options="currentSeason.teams"
                      optionLabel="name"
                      optionValue="id"
                      :placeholder="$t('select-team')"
                      v-model="constraint.no_play_team"
                    />
                  </div>
                </div>
              </div>
              <div class="modal-actions p-text-center">
                <div v-if="!this.constraint.id && d2 != 6">
                  <b-checkbox v-model="applyAll" name="Apply to All Teams">
                    {{ $t("apply-this-constraint-to-all-teams-in-division") }}
                  </b-checkbox>
                  <br /><br />
                </div>
                <Button class="p-button-lg" :disabled="!valid" @click="saveContraints" :label="$t('Button.save')" />
                <br /><br />
                <Button class="p-button-sm p-button-text" @click="cancel" :label="$t('Button.cancel')"> </Button>
                <div v-if="!isProduction">
                  {{ constraint }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
import api from "@/api";

export default {
  components: {},
  props: ["input", "team"],
  // dddd
  data() {
    return {
      applyAll: false,
      times: {
        a: null,
        b: null,
        c: null,
        d: null,
      },
      showDatepicker: true,
      d1: 0, // 0 Weekly or 1 Specific Date
      d2: 0, // 0 All day, 1 block time, or 2 game limit
      days: [
        { name: this.$t("Week.short.sun"), value: 0 },
        { name: this.$t("Week.short.mon"), value: 1 },
        { name: this.$t("Week.short.tue"), value: 2 },
        { name: this.$t("Week.short.wed"), value: 3 },
        { name: this.$t("Week.short.thu"), value: 4 },
        { name: this.$t("Week.short.fri"), value: 5 },
        { name: this.$t("Week.short.sat"), value: 6 },
      ],
      constraint: {
        team_id: this.team.id,
        is_all_day: true,
        wday: "",
        not_between_start: null,
        start_date: null,
        end_date: null,
        not_between_end: null,
        not_before: null,
        not_after: null,
        is_home_only: null,
        max_games: null,
        max_travel_home: null,
        max_travel_last: null,
        no_play_team: null,
        dates: [],
        weekdays: this.isProduction ? [] : [0],
      },
    };
  },
  computed: {
    valid() {
      this.po(this.constraint);
      var day = this.constraint.start_date || this.constraint.weekdays.length > 0 || this.constraint.wday;
      var allDay = this.constraint.is_all_day && day;
      var timeRange =
        day &&
        ((this.constraint.not_between_start &&
          this.constraint.not_between_end &&
          new Date("01/01/2011 " + this.constraint.not_between_start) <
            new Date("01/01/2011 " + this.constraint.not_between_end)) ||
          this.constraint.not_before ||
          this.constraint.not_after);
      var maxGames = day && this.constraint.max_games;
      console.log(day, allDay, timeRange, maxGames);
      return (
        allDay ||
        timeRange ||
        maxGames ||
        this.maxhome ||
        this.maxlast ||
        (this.noteam && this.constraint.no_play_team) ||
        this.musthome
      );
    },
    existing() {
      return !!this.constraint.id;
    },
    isWeekly() {
      return this.d1 == 0;
    },
    isSpecificDate() {
      return this.d1 == 1;
    },
    isRange() {
      return this.d1 == 2;
    },
    step2() {
      return this.constraint.weekdays.length > 0 || this.constraint.start_date;
    },
    step3() {
      return true;
    },
    timerange() {
      return this.d2 == 1;
    },
    maxgames() {
      return this.d2 == 2;
    },
    maxhome() {
      return this.d2 == 3;
    },
    maxlast() {
      return this.d2 == 4;
    },
    musthome() {
      return this.d2 == 5;
    },
    noteam() {
      return this.d2 == 6;
    },
  },
  watch: {
    "constraint.dates": function() {
      this.constraint.start_date = this.constraint.dates[0];
      this.constraint.end_date = this.constraint.dates[1];
    },
    d1: function(val) {
      this.constraint.start_date = undefined;
      this.constraint.weekdays = [];
      this.constraint.wday = undefined;
      this.d2 = 0;
      this.constraint.is_all_day = true;
      this.constraint.dates = [];
    },
    d2: function(val) {
      console.log("New D2: " + val);
      this.applyAll = false;
      this.constraint.is_all_day = false;
      this.constraint.max_games = null;
      this.constraint.not_between_start = null;
      this.constraint.not_between_end = null;
      this.constraint.not_before = null;
      this.constraint.not_after = null;
      this.constraint.is_home_only = false;
      this.constraint.max_travel_last = null;
      this.constraint.max_travel_home = null;
      this.constraint.no_play_team = null;

      if (val != 1) {
        this.constraint.is_all_day = true;
      }

      if (val == 2) {
        this.constraint.max_games = 1;
      } else if (val == 3) {
        this.constraint.max_travel_home = 5;
      } else if (val == 4) {
        this.constraint.max_travel_last = 5;
      } else if (val == 5) {
        this.constraint.is_home_only = true;
      }
    },
  },
  methods: {
    clear(num) {
      if (num == 1) {
        this.times.a = null;
        this.times.b = null;
        this.constraint.not_between_start = null;
        this.constraint.not_between_end = null;
      } else {
        this.times.c = null;
        this.times.d = null;
        this.constraint.not_before = null;
        this.constraint.not_after = null;
      }
    },
    setStartDate(e) {
      console.log(e);
      this.constraint.start_date = e;
      this.showDatepicker = false;
      console.log("SDP false");
    },
    setEndDate(e) {
      console.log(e);
      this.constraint.end_date = e;
    },
    setNotBefore(event) {
      console.log("Set not before", event);
      this.clear(1);
      this.constraint.not_before = this.formatAMPM(new Date(event));
      this.constraint.wday = undefined;
      this.checkTimes();
    },
    setNotAfter(event) {
      console.log("Set not after", event);
      this.clear(1);
      this.constraint.not_after = this.formatAMPM(new Date(event));
      this.constraint.wday = undefined;
      this.checkTimes();
    },
    setBetweenStart(event) {
      // console.log("Set between start", event)
      this.clear(2);
      this.constraint.not_between_start = this.formatAMPM(new Date(event));
      this.constraint.wday = undefined;
      this.checkTimes();
    },
    setBetweenEnd(event) {
      // console.log("Set between end", event)
      this.clear(2);
      this.constraint.not_between_end = this.formatAMPM(new Date(event));
      this.constraint.wday = undefined;
      this.checkTimes();
    },
    checkTimes() {
      // console.log("🔴 " + this.times.a + ' ----> ' + this.times.b, this.times.a >= this.times.b )
      // console.log("🟠 " + this.times.c + ' ----> ' + this.times.d, this.times.c >= this.times.d )
      // if ( this.constraint.not_between_start && this.constraint.not_between_end && this.constraint.not_between_start >= this.constraint.not_between_end ) {
      if (this.times.a && this.times.b && this.times.a >= this.times.b) {
        this.makeToast("info", this.$t("Toast.end-time-must-be-after-start-time"));
        // this.clear(1)
        // this.times.b = null
        // this.constraint.not_between_end = null
      }
      // if ( this.constraint.not_before && this.constraint.not_after && this.constraint.not_before >= this.constraint.not_after ) {
      if (this.times.c && this.times.d && this.times.c >= this.times.d) {
        this.makeToast("info", this.$t("Toast.end-time-must-be-after-start-time"));
        // this.clear(2)
        // this.times.d = null
        // this.constraint.not_after = null
      }
    },
    resetStuff() {
      this.max_games = null;
      this.d1 = 0;
      this.d2 = 0;
      this.constraint = {
        team_id: this.team.id,
        is_all_day: "",
        wday: "",
        not_between_start: null,
        start_date: null,
        not_between_end: null,
        not_before: null,
        not_after: null,
        is_home_only: null,
        max_games: null,
        dates: [],
        weekdays: [],
      };
      this.clear(1);
      this.clear(2);
    },
    setConstraint() {
      this.constraint = this.input ? JSON.parse(JSON.stringify(this.input)) : this.constraint;
    },
    saveContraints() {
      if (this.constraint.id) {
        this.updateConstraints();
      } else {
        this.createConstraints();
      }
    },
    cancel() {
      this.$emit("refresh");
      this.resetStuff();
      this.$modal.hide("timeconstraint");
    },
    createConstraints() {
      api
        .createTeamTimeConstraint(this.team.id, this.constraint, this.applyAll)
        .then(response => {
          this.$emit("refresh");
          this.makeToast("success", this.$t("Toast.created-time-constraint"));
          if (this.isProduction) {
            this.resetStuff();
            this.$modal.hide("timeconstraint");
          }
        })
        .catch(error => {
          this.errors = error.response.data.errors;
        });
    },
    removeConstraints() {},
  },
  mounted() {
    // this.$modal.show('timeconstraint')
  },
};
</script>

<style scoped lang="scss">
.modal-content {
  min-height: 200px;
}

#datefield {
  max-width: 200px;
  margin: 0 auto;
  .input {
    text-align: center;
    background: red;
  }
}
</style>
